import { ElementType } from "react"
import styled, { PolymorphicComponentProps } from "styled-components"
import { Typography, TypographyVariant } from "../../typography"

interface LabeProps {
  as?: ElementType
  $isSelected?: boolean
  $variant?: TypographyVariant
}

const Label = styled(Typography).attrs<LabeProps>(({ as, $isSelected, $variant }) => ({
  as: as ?? "span",
  $isSelected,
  $variant: $variant ?? "body-4-medium",
}))<{ $isSelected?: boolean }>`
  color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.grey.$600 : theme.colors.grey.$500)};
  display: flex;
  align-items: center;
`

interface LabelContainerProps {
  as?: ElementType
  $isSelected?: boolean
}

const LabelContainer = styled(Typography).attrs<LabelContainerProps>(({ as, $isSelected }) => ({
  as: as ?? "button",
  $isSelected,
}))<{ $isSelected?: boolean }>`
  border-radius: 0.5rem;
  padding: 1rem 0.75rem;
  min-height: 3.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  &::after {
    content: "";
    position: absolute;
    border-bottom: 3px solid;
    border-color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.grey.$600 : "transparent")};
    bottom: 0;
    left: 0.75rem;
    right: 0.75rem;
  }
  &:hover::after {
    border-color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.grey.$600 : theme.colors.grey.$200)};
  }
  &:active::after {
    border-color: ${({ theme }) => theme.colors.grey.$600};
  }
  &:focus-visible {
    border: none;
    box-shadow: 0px 0px 0px 4px ${({ theme }) => theme.colors.secondary.$100};
  }
`

type TabProps<C extends React.ElementType> = PolymorphicComponentProps<
  "web",
  {
    $variant?: TypographyVariant
    $isSelected?: boolean
  },
  C,
  C
>

export const DeprecatedTab = <C extends React.ElementType = "button">({
  $isSelected = false,
  children,
  as,
  ...props
}: TabProps<C>) => {
  return (
    <LabelContainer role="tab" aria-selected={$isSelected} as={as} $isSelected={$isSelected} {...props}>
      <Label $isSelected={$isSelected}>{children}</Label>
    </LabelContainer>
  )
}
